import React, { useState } from 'react';
import { IconButton, TextField, CircularProgress } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { firestore_db } from '../../config/firebase_config';

const SecondDeviceIdCell = ({ rowData, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(rowData.second_device_id || "");
  const [isSaving, setIsSaving] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
    setValue(rowData.second_device_id || "");
  };

  const handleCancel = () => {
    setIsEditing(false);
    setValue(rowData.second_device_id || "");
  };

  const handleSave = async () => {
    const trimmedValue = value.trim();
    setIsSaving(true);
    try {
      await firestore_db.doc(`users/${rowData.id}`).update({
        second_device_id: trimmedValue || null
      });
      onUpdate(rowData.id, trimmedValue || null);
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to update second_device_id:", error);
      alert("Failed to update Second Device ID.");
    } finally {
      setIsSaving(false);
    }
  };

  if (isEditing) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <TextField
          value={value}
          onChange={(e) => setValue(e.target.value)}
          size="small"
          autoFocus
          disabled={isSaving}
          placeholder="Empty"
          inputProps={{ style: { padding: '4px 8px' } }}
        />
        {isSaving ? (
          <CircularProgress size={20} />
        ) : (
          <>
            <IconButton size="small" onClick={handleSave} color="primary">
              <CheckIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={handleCancel} color="secondary">
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        )}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: '150px' }}>
      <span>{rowData.second_device_id || "—"}</span>
      <IconButton size="small" onClick={handleEdit}>
        <EditIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default SecondDeviceIdCell;
